module.exports = __webpack_public_path__ + "media/images/social/youtube-244ad6395f96e4fd4a2d484f5a98906f.png";